<script setup>
// No imports needed for now
import carousel3 from '../../assets/carousel3.jpg'
</script>

<template>
  <section
    class="py-16 relative px-4 md:px-8 lg:px-16 text-white bg-cover bg-center bg-no-repeat mt-6"
    :style="{ backgroundImage: `url(${carousel3})` }"
  >
    <!-- Overlay to darken background for readability -->
    <div class="bg-[#00000077] bg-opacity-70 w-full h-full absolute inset-0 z-0"></div>

    <div class="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="bg-dark-blue bg-opacity-90 p-8 rounded-lg shadow-xl">
        <h2 class="text-3xl md:text-4xl font-bold mb-4">Contact Us</h2>
        <p class="text-gray-300 mb-6">
          If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
        </p>
        <form class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input type="text" placeholder="Enter Name *"
            class="p-3 rounded-md bg-dark-blue border border-gray-600 focus:outline-none focus:ring-2 focus:ring-bright-yellow" />
          <input type="email" placeholder="Enter Email *"
            class="p-3 rounded-md bg-dark-blue border border-gray-600 focus:outline-none focus:ring-2 focus:ring-bright-yellow" />
          <input type="tel" placeholder="Enter Phone No *"
            class="p-3 rounded-md bg-dark-blue border border-gray-600 focus:outline-none focus:ring-2 focus:ring-bright-yellow" />
          <select
            class="p-3 rounded-md bg-dark-blue border border-gray-600 focus:outline-none focus:ring-2 focus:ring-bright-yellow text-gray-400">
            <option>Select Course</option>
            <option>Computer Science</option>
            <option>Pharmacy</option>
            <option>Design</option>
          </select>
          <textarea placeholder="Message *" rows="4"
            class="sm:col-span-2 p-3 rounded-md bg-dark-blue border border-gray-600 focus:outline-none focus:ring-2 focus:ring-bright-yellow"></textarea>
          <button type="submit"
            class="sm:col-span-2 bg-bright-yellow text-white px-8 py-3 rounded-full font-semibold hover:bg-opacity-80 transition-all duration-300 mt-4">
            Register Now
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<style scoped>
.bg-dark-blue {
  background-color: #0b1d40;
}

.bg-bright-yellow {
  background-color: #FDB813;
}
</style>
